export var Locations;
(function (Locations) {
    Locations["Messaging"] = "Messaging";
    Locations["System"] = "System";
    Locations["Whitelisting"] = "Whitelisting";
    Locations["Activation"] = "Activation";
    Locations["Testing"] = "Testing";
    Locations["User"] = "User";
    Locations["Newsletter"] = "Newsletter";
})(Locations || (Locations = {}));
;
